export default "__VITE_ASSET__CW_jg4yx__"